export default "__VITE_ASSET__BFm4CkpJ__"